import { useEffect, useState, type FunctionComponent, } from "react";
import { useModalizeStore, Dollars, TokenPill, WEI, } from "@components";
import { useEscrowStore, } from "@stores/escrow";
import { useMessengerStore, } from "@bracket/react-messenger";
import { UnstakeWarning, } from "./UnstakeWarning";
import { UnstakeAmount, } from "./UnstakeAmount";
import { Button, } from "@bracket/react-button";
import { n, getBlockLink, } from "@helpers";


import "./Unstake.scss";
import type { TokenDefinition, } from "@bracket/addressbook"; 

export declare type UnstakeRowProps = {
	token: TokenDefinition;
};


export const UnstakeRow: FunctionComponent<UnstakeRowProps> = ({
	token,
}) => {

	const classes = () => [ "unstake-row" ].join(" ");
	const { balances, balanceUSD, setWithdrawInToken, withdraw, busy, reset, } = useEscrowStore();
	const [ confirming, setConfirming, ] = useState(false);
	const { dismiss, modalize, } = useModalizeStore();
	const { sendMessage, } = useMessengerStore();

	const balance = balances[token.label];


	if( typeof balance !== "bigint" )
		throw new Error(`failed gaining balance for token "${token.label}"`);

	const onClick = ( ) => {
		setWithdrawInToken(token);
		const buttons = [
			{ button: Button, buttonProps: { label: "Stay staked and win", type: "good", onClick: onReject, variant: "primary", flexible: true, } },
			{ button: Button, buttonProps: { label: "Unstake and lose out", type: "bad", onClick: onConfirm, variant: "error", flexible: true, } },
		];
		modalize({
			component: UnstakeWarning,
			props: {
				token: token.label,
			},
			title: "Sorry to see you go!",
			buttons,
		});
	}

	const onConfirm = () => {
		setConfirming(true);
		const buttons = [
			{ button: Button, buttonProps: { label: "Unstake early", variant: "error", onClick: onWithdraw, flexible: true, busy, }},
		]
		modalize({ component: UnstakeAmount, props: { }, title: "Enter the amount to unstake", buttons, onClose: onCloseUnstakeAmount, });
	}

	const onCloseUnstakeAmount = () => {
		reset();
	}

	const onWithdraw = () => {
		( async () => {
			const response = await withdraw();
			const { code, status: severity, message, } = response;
			switch( code ) {
				case "SUCCESS":
					const blockChainLink = getBlockLink(response.hash);
					sendMessage({ title: "Stake", severity, message, blockChainLink, });
					window.history.pushState({}, "", "/stake/balances");
					reset();
					break;

				case "CANCELLED":
				case "UNDERFUND":
				case "UNHANDLED":
					sendMessage({ title: "Stake", severity, message, });
					reset();
					break;
			
				default:
					throw new Error(`StakeNext::unhandled response code "${code}"`)

			}
			setConfirming(false);
			reset();
			dismiss();
		})();
	}

	const onReject = () => dismiss();


	useEffect(() => {
		if( confirming ) {
			dismiss();
			const buttons = [
				{ button: Button, buttonProps: { label: "Unstake early", variant: "error", onClick: onWithdraw, flexible: true, busy, }},
			]
			modalize({ component: UnstakeAmount, props: { }, title: "Enter the amount to unstake", buttons, });
		}
	}, [ busy, ]);

	return (
		<tr className={classes()}>
			<td className="stake"><TokenPill token={token}/></td>
			<td className="balance"><WEI value={balance} /></td>
			<td className="amount"><Dollars value={balanceUSD(token)} /></td>
			<td className="action">
				<div className="cont">
					<Button label="unstake" variant="primary-outline" onClick={onClick} disabled={ n(balance) <= 0.00001 } />
				</div>
			</td>
		</tr>
	);

}
